import { render, staticRenderFns } from "./Auth0LoginRoute.vue?vue&type=template&id=9f3a2524"
import script from "./Auth0LoginRoute.vue?vue&type=script&lang=ts"
export * from "./Auth0LoginRoute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports